import { Box, styled } from "@mui/system"

export const BoxMenu = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: 'auto',
    height: "minContent",
    backgroundColor: theme.palette.background.paper,
    padding: "24px",
}))
